export default "__VITE_ASSET__CJLGy5Yu__"